import { page } from '$app/stores';
import { configuration as configurationForFr } from '$lib/constants/advertising/fr/configuration';
import { get } from 'svelte/store';

export function getAdvertiserData() {
	const pageStore = get(page);
	const lang = pageStore.data.lang;
	if (lang === 'fr') {
		return configurationForFr;
	}
}
